import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpConfigInterceptor } from './interceptors/httpconfig.interceptor';

import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OtpPageComponent } from './view/pages/otp-page/otp-page.component';
import { RegistrationFormPageComponent } from './view/pages/registration-form-page/registration-form-page.component';
import { TermsAndConditionsComponent } from './view/components/terms-and-conditions/terms-and-conditions.component';
import { BirthdayComponent } from './view/components/birthday/birthday.component';
import { AppRoutingModule } from './app-routing.module';
import { OtpValidatedGuard } from './guards/otp-validated/otp-validated.guard';
import { EnumToArrayPipe } from './pipes/enum-to-array/enum-to-array.pipe';
import { NameFormatPipe } from './pipes/name-format/name-format.pipe';
import { IncludedInListValidatorDirective } from './validators/included-in-list-validator/included-in-list-validator.directive';
import { FlexLayoutModule } from '@angular/flex-layout';



// Angular material modules ---------------------------------------
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatTabsModule} from '@angular/material/tabs';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
// ----------------------------------------------------------------

import { NgOtpInputModule } from 'ng-otp-input';
import { OtpSendComponent } from './view/components/otp-send/otp-send.component';
import { OtpValidateComponent } from './view/components/otp-validate/otp-validate.component';
import { StoreNotFoundComponent } from './view/pages/store-not-found/store-not-found.component';
import { LoadingScreenComponent } from './view/components/loading-screen/loading-screen.component';
import { OtpLimitPageComponent } from './view/pages/otp-limit-page/otp-limit-page.component';

@NgModule({
  declarations: [
    AppComponent,
    OtpPageComponent,
    RegistrationFormPageComponent,
    BirthdayComponent,
    TermsAndConditionsComponent,
    EnumToArrayPipe,
    NameFormatPipe,
    IncludedInListValidatorDirective,
    OtpSendComponent,
    OtpValidateComponent,
    StoreNotFoundComponent,
    LoadingScreenComponent,
    OtpLimitPageComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
   
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatTabsModule,
    NgOtpInputModule,
    MatSnackBarModule,
    MatProgressSpinnerModule
  ],
  providers: [
    
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    },
    OtpValidatedGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
